import request from '../../axios';

const PostLabRequirement = async (payload: ILabRequirementPayload) => {
  const newPayload = {
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    only_massage_buyer: payload.only_massage_buyer || false,
    is_change_title: payload?.is_change_title,
  };
  const res = await request.post(`api/v2/wanted/lab-requirement`, {
    ...newPayload,
  });

  return res.data;
};

export default PostLabRequirement;
